import { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import type { InfoSlideQuestion } from '../../../types';

export interface InfoSlideContentProps {
  question: InfoSlideQuestion;
}

/**
 * Content panel for an InfoSlide question.
 *
 * Shows a truncated preview of the slide body text and, when present, the
 * image URL. No interactive elements — info slides have no catalog items.
 * @param root0
 * @param root0.question
 */
export const InfoSlideContent: FC<InfoSlideContentProps> = ({ question }) => (
  <Stack spacing={1}>
    {question.details && (
      <Typography variant="body2" color="text.secondary">
        {question.details}
      </Typography>
    )}
    {question.imageUrl && (
      <Typography variant="caption" color="text.secondary">
        Image: {question.imageUrl}
      </Typography>
    )}
  </Stack>
);
